
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Rule from './rule'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "rule"
    }}>{`Rule`}</h1>
    <Playground __position={0} __code={'<code>\n  --ds-border-rule: 0.0625rem solid var(--ds-color-london-85);\n  <br />\n  --ds-border-rule--emphasised: 0.0625rem solid var(--ds-color-london-5);\n  <br />\n  --ds-border-rule--inverse: 0.0625rem solid var(--ds-color-london-35);\n  <br />\n  --ds-border-rule--inverse-emphasised: 0.0625rem solid\n  var(--ds-color-london-100);\n  <br />\n  --ds-border-rule--heavy: 0.25rem solid var(--ds-color-london-5);\n  <br />\n  --ds-border-rule--inverse-heavy: 0.25rem solid var(--ds-color-london-100);\n  <br />\n  --ds-border-rule--accent: 0.25rem solid var(--ds-color-economist-red);\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      fontFamily: 'monospace'
    }} mdxType="Playground">
  <code>
    --ds-border-rule: 0.0625rem solid var(--ds-color-london-85);<br />
    --ds-border-rule--emphasised: 0.0625rem solid var(--ds-color-london-5);<br />
    --ds-border-rule--inverse: 0.0625rem solid var(--ds-color-london-35);<br />
    --ds-border-rule--inverse-emphasised: 0.0625rem solid var(--ds-color-london-100);<br />
    --ds-border-rule--heavy: 0.25rem solid var(--ds-color-london-5);<br />
    --ds-border-rule--inverse-heavy: 0.25rem solid var(--ds-color-london-100);<br />
    --ds-border-rule--accent: 0.25rem solid var(--ds-color-economist-red);
  </code>
    </Playground>
    <h2 {...{
      "id": "rule-1"
    }}>{`Rule`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For all standard usage. Horizontal placement.`}</p>
    <Playground __position={1} __code={'<Rule />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-inverse"
    }}>{`Rule (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For all standard usage. Horizontal placement.`}</p>
    <Playground __position={3} __code={'<Rule inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule inverse mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-emphasised"
    }}>{`Rule (emphasised)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For indicating importance. Horizontal placement.`}</p>
    <Playground __position={5} __code={'<Rule rule=\"emphasised\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule rule='emphasised' mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-inverse-emphasised"
    }}>{`Rule (inverse, emphasised)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For indicating importance. Horizontal placement.`}</p>
    <Playground __position={7} __code={'<Rule inverse rule=\"emphasised\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule inverse rule='emphasised' mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-heavy"
    }}>{`Rule (heavy)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`For indicating highest importance. Horizontal placement.`}</p>
    <Playground __position={9} __code={'<Rule rule=\"heavy\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule rule='heavy' mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-inverse-heavy"
    }}>{`Rule (inverse, heavy)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`For indicating highest importance. Horizontal placement.`}</p>
    <Playground __position={11} __code={'<Rule inverse rule=\"heavy\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule inverse rule='heavy' mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-accent"
    }}>{`Rule (accent)`}</h2>
    <h3 {...{
      "id": "description-6"
    }}>{`Description`}</h3>
    <p>{`A visual cue for landmarks.`}</p>
    <Playground __position={13} __code={'<Rule rule=\"accent\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule rule='accent' mdxType="Rule" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "rule-inverse-accent"
    }}>{`Rule (inverse, accent)`}</h2>
    <h3 {...{
      "id": "description-7"
    }}>{`Description`}</h3>
    <p>{`A visual cue for landmarks.`}</p>
    <Playground __position={15} __code={'<Rule inverse rule=\"accent\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Rule
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Rule inverse rule='accent' mdxType="Rule" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;